import { render, staticRenderFns } from "./add_dataset.vue?vue&type=template&id=46b7ba84"
import script from "./add_dataset.vue?vue&type=script&lang=js"
export * from "./add_dataset.vue?vue&type=script&lang=js"
import style0 from "./add_dataset.vue?vue&type=style&index=0&id=46b7ba84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports